<template>
  <section class="section cms-assistance">
    <b-container>
      <div class="cms-assistance__head">
        <h5
          v-if="title"
          class="vb-heading h5 cms-assistance__title"
          v-html="title"
        ></h5>
        <div v-if="text" class="cms-assistance__subtitle" v-html="text"></div>
      </div>

      <b-row class="justify-content-center">
        <b-col
          v-for="(column, column_index) in resolved_columns"
          :key="`cms-assistance-${column_index}`"
          xs="12"
          sm="6"
          lg="3"
          class="cms-assistance__col"
        >
          <div class="cms-assistance__item">
            <vb-icon
              v-if="column.icon"
              :name="column.icon"
              :dotted="true"
              class="cms-assistance__icon"
            />
            <div
              v-if="column.title"
              class="h6 vb-heading cms-assistance__label"
              v-html="column.title"
            ></div>
            <div v-if="column.resolved_link" class="cms-assistance__text">
              <content-link :link="column.resolved_link">
                <span
                  v-html="
                    column.resolved_link.label || column.resolved_link.href
                  "
                ></span>
              </content-link>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  /**
   * CMS `assistance` block: heading + grid of assistance channels.
   * Schema (props): `{ title, text, columns: [{ icon, title, link }] }`.
   * The item is NOT clickable as a whole: the link (when present) is a separate
   * `<a>` element, as in the original component (blocks/prefooter.vue).
   */
  import { resolve_link } from './content-utilities';
  import ContentLink from './content-link.vue';

  export default {
    name: 'assistance',

    components: { 'content-link': ContentLink },

    props: {
      title: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
      columns: {
        type: Array,
        default: () => [],
      },
    },

    computed: {
      resolved_columns() {
        return (this.columns || []).map((column) => ({
          ...column,
          resolved_link: resolve_link(column.link),
        }));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cms-assistance {
    &__head {
      text-align: center;
      margin-bottom: $grid-gutter-width;
    }

    &__item {
      background: $white;
      text-align: center;
      border-radius: $border-radius-lg * 2;
      padding: $grid-gutter-width 0;
      margin: $grid-gutter-width/3 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    &__icon {
      margin: 0 auto 1rem;

      ::v-deep svg {
        width: auto;
        height: 30px;
      }
    }

    &__text {
      font-size: $font-size-md;
    }
  }
</style>
